// @flow

export const GUARANTEE: "guarantee" = "guarantee";
export const PARTICIPATION: "participation" = "participation";
export const GUARANTEE_AND_PARTICIPATION: "guarantee_and_participation" =
  "guarantee_and_participation";
export const NO_APPROVAL: "no_approval" = "no_approval";

export type GuaranteeDecision =
  | typeof GUARANTEE
  | typeof PARTICIPATION
  | typeof GUARANTEE_AND_PARTICIPATION
  | typeof NO_APPROVAL;

export const BUBA_NOT_ALLOWED: "buba_not_allowed" = "buba_not_allowed";
export const BUBA_NOT_INTERESTED: "buba_not_interested" = "buba_not_interested";
export const BOTH_INTERESTED: "both_interested" = "both_interested";
export const SKIPPED: "skipped" = "skipped";

export type GuaranteeInterestAnswer =
  | typeof BUBA_NOT_ALLOWED
  | typeof BUBA_NOT_INTERESTED
  | typeof BOTH_INTERESTED
  | typeof SKIPPED;
